import {DataObjectId, ProjectType} from 'yougile-model'
import {Hub} from 'yougile-model'

export interface ProjectProxy {
  readonly parentCompanyId: DataObjectId
  readonly projectId: DataObjectId
  readonly projectName: string
  readonly projectType?: ProjectType
}

export const ProjectProxy = {
  create: ({companyId, title, id, data}: Hub): ProjectProxy => ({
    parentCompanyId: companyId,
    projectId: id,
    projectName: title,
    projectType: data?.projectType
  })
}
